import { geistSans } from "@/components/atoms/buttons/Button";
import { Input as ShadcnInput } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { ComponentProps } from "react";

const PromoInput = ({ placeholder = "", className, ...props }: ComponentProps<"input">) => {
  return (
    <ShadcnInput
      className={cn(
        "border-festi-100 placeholder:text-pink-tertiary focus-visible:border-pink-primary focus-visible:ring-festi-100/50 text-dark-primary aria-invalid:text-pink-primary max-h-full min-h-[3.625rem] rounded-md border px-4 py-3.5 text-lg font-normal duration-300 placeholder:text-lg placeholder:font-light focus-visible:ring-[3px]",
        geistSans.className,
        className
      )}
      placeholder={placeholder}
      {...props}
    />
  );
};

export default PromoInput;
